import { DataCellProps } from '../../types';

const DataTypeDataCell = ({ _customRowProps, dataTypeLabel }: DataCellProps) => {
  return <div>{dataTypeLabel}</div>;
};

export default DataTypeDataCell;
